import React, { useState, useRef, useMemo, useEffect } from 'react';
import './ContactSlider.css';

const ContactSlider = ({ foirRefData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);

  const formatMatchScore = (score) => {
    if (score === 'N/A') {
      return 'N/R';
    }
    if (score === 'Blank') {
      return 'Blk';
    }
    if (score === null || score === undefined) {
      return null;
    }
    return score;
  };

  const contacts = useMemo(() => {
    const createContact = (n) => ({
      name: foirRefData[`contact${n}Name`],
      relation: foirRefData[`contact${n}Relation`],
      verifiedName: foirRefData[`contact${n}NameAsPerMobileLookup`] || ``,
      phone: foirRefData[`contact${n}`],
      nameMatchScore: foirRefData[`contact${n}NameMatchScore`] || null,
    });

    const availableContacts = [];
    if (foirRefData?.contact1) availableContacts.push(createContact(1));
    if (foirRefData?.contact2) availableContacts.push(createContact(2));
    if (foirRefData?.contact3) availableContacts.push(createContact(3));
    return availableContacts;
  }, [foirRefData]);

  useEffect(() => {
    if (scrollContainerRef.current) {
      const scrollAmount = scrollContainerRef.current.offsetWidth * currentIndex;
      scrollContainerRef.current.scrollTo({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }
  }, [currentIndex]);

  const handlePrev = () => setCurrentIndex((prev) => Math.max(prev - 1, 0));
  const handleNext = () => setCurrentIndex((prev) => Math.min(prev + 1, contacts.length - 1));

  if (contacts.length === 0) return (<><p style={{marginLeft:'3em'}}>---</p></>);

  return (
    <div className="contact-slider-container">
      <div className="slider-wrapper">
        <button className="slider-btn prev" onClick={handlePrev} disabled={currentIndex === 0}>
          {'<'}
        </button>

        <div className="scroll-area" ref={scrollContainerRef}>
          {contacts.map((contact, index) => {
            const formattedScore = formatMatchScore(contact.nameMatchScore);

            return (
              <div className="contact-card" key={index}>
                <div className="card-main-content">
                  <div className="card-details">
                    <p className="contact-name">{contact.name}</p>
                    <p className="contact-relation">{contact.relation}</p>
                    {contact.verifiedName && (
                      <p className={`contact-verified ${
                          contact.verifiedName === 'No Record Found' ? 'no-record' : ''
                        }`}
                      >
                        {contact.verifiedName === 'No Record Found'
                          ? 'No Record Found'
                          : (
                              <>
                                <span style={{ color: '#6b7280' }}>MLN: </span>
                                {contact.verifiedName}
                              </>
                            )
                        }

                        {formattedScore != null && 
                          ` (${formattedScore}${
                            ['N/R', 'Blk'].includes(formattedScore) ? '' : '%'
                          })`
                        }
                      </p>
                    )}
                    <span className="contact-phone">{contact.phone}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button className="slider-btn next" onClick={handleNext} disabled={currentIndex === contacts.length - 1}>
          {'>'}
        </button>
      </div>
    </div>
  );
};

export default ContactSlider;